import { keepPreviousData, useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormTemplate } from '../../../types/FormTemplate';
import { PaginationMeta } from '../../../types/pagination';

type FormTemplateResponse = {
  data: FormTemplate[];
  meta: PaginationMeta;
};

type UseGetAllFormTemplateParams = {
  page?: number;
  per_page?: number;
  search?: string,
  filters?: {
    archived?: boolean;
  }
};

type UseGetAllFormTemplateProps = {
  params?: UseGetAllFormTemplateParams;
  enabled?: boolean;
};

const fetchAllFormTemplate = async ({ params }: UseGetAllFormTemplateProps) => {
  const response = await CustomAxios.get<FormTemplateResponse>(`form_templates`, { params });
  const { data } = response;
  return data;
};

export function useGetAllFormTemplate({ params, enabled = true }: UseGetAllFormTemplateProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.allFormTemplates, params],
    queryFn: () => fetchAllFormTemplate({ params }),
    placeholderData: keepPreviousData,
  });
}
